// extracted by mini-css-extract-plugin
module.exports = {"modalCommitParent":"styles_modalCommitParent__1G5Ry","modalCommitButtons":"styles_modalCommitButtons__-mqfw"};